import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const products = [
  {
    id: 1,
    defaultImg: "images/whiteshut.jpg",
    hoverTitle:
      " Loremen Ipsumes is simply dummy text of the printing and typesetting industry. @fashionHubc fashionHub #model #fashionk",
  },
  {
    id: 2,
    defaultImg: "images/store-3.jpg",
    hoverTitle:
      " Loremen Ipsumes is simply dummy text of the printing and typesetting industry. @fashionHubc fashionHub #model #fashionk",
  },
  {
    id: 3,
    defaultImg: "images/store-4.jpg",
    hoverTitle:
      " Loremen Ipsumes is simply dummy text of the printing and typesetting industry. @fashionHubc fashionHub #model #fashionk",
  },
  {
    id: 4,
    defaultImg: "images/kasmiri.jpg",
    hoverTitle:
      " Loremen Ipsumes is simply dummy text of the printing and typesetting industry. @fashionHubc fashionHub #model #fashionk",
  },
  {
    id: 5,
    defaultImg: "images/fitness-2.jpg",
    hoverTitle:
      " Loremen Ipsumes is simply dummy text of the printing and typesetting industry. @fashionHubc fashionHub #model #fashionk",
  },
];

const AboutUs = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 5000,
    slidesToShow: 4, // Adjust as needed
    slidesToScroll: 3,
    arrows: false,
  };

  return (
    <>
      <div className="inner-banner banner vd-banner">
        <div className="video-section">
          <div className=" videoPosition">
            <video autoplay="" loop="" muted="muted" poster="images/hero-1.jpg">
              <source src="images/video/market-location.mp4" type="video/mp4" />
            </video>
          </div>
        </div>
        <div className="container position-absolute">
          <div className="inner-banner-txt">
            <h1 className="banner-banner-heading text-white fs-60 heading">
              Welcome to Fashion Hub{" "}
            </h1>
            <h2 className="text-white fs-35  bg-site d-inline-block p-3">
              Nice to Meet You !
            </h2>
            <nav aria-label="breadcrumb" className="breadcrumb-nav">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <a href="index-2.html">Home</a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  About Us{" "}
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </div>

      <div className="main-section abt-me">
        <div className="container">
          <div className="row">
            <div className="col-lg-4 col-sm-4 col-xs-12">
              <div className="abt-me-box text-center">
                <span className="mbri-hearth" />
                <h3 className="fs-16 font-weight-normal">
                  CANADA BASED FASHION RETAILER
                </h3>
              </div>
            </div>
            <div className="col-lg-4 col-sm-4 col-xs-12">
              <div className="abt-me-box text-center">
                <span className="mbri-delivery" />
                <h3 className="fs-16 font-weight-normal">
                  NEW ARRIVALS WEEKLY{" "}
                </h3>
              </div>
            </div>
            <div className="col-lg-4 col-sm-4 col-xs-12">
              <div className="abt-me-box text-center">
                <span className="mbri-map-pin" />
                <h3 className="fs-16 font-weight-normal">OUR STORE </h3>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="about-gallery">
        <div className="container">
          <div className="owner-box">
            <img src="images/about-me.jpg" alt="owner" />
            <div className="owner-txt text-white">
              <div className="founder-heading fs-45 text-white">Founders</div>
              <div className="fname">John Denny &amp; Rhena John</div>
            </div>
          </div>
        </div>
      </div>

      <div className="main-section store-gallery">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-6 col-sm-6 col-xs-6 p-1">
              <div className="store-img object-fit">
                <img src="images/store-1.jpg" alt="Store" />
              </div>
            </div>
            {/* col */}
            <div className="col-lg-6 col-sm-6 col-xs-6 p-1">
              <div className="store-img object-fit">
                <img src="images/store-2.jpg" alt="Store" />
              </div>
            </div>
            {/* col */}
            <div className="col-lg-6 col-sm-6 col-xs-6 p-1">
              <div className="store-img object-fit">
                <img src="images/store-3.jpg" alt="Store" />
              </div>
            </div>
            {/* col */}
            <div className="col-lg-6 col-sm-6 col-xs-6 p-1">
              <div className="store-img object-fit">
                <img src="images/store-4.jpg" alt="Store" />
              </div>
            </div>
            {/* col */}
            <div className="col-lg-6 col-sm-6 col-xs-6 p-1">
              <div className="store-img object-fit">
                <img src="images/store-5.jpg" alt="Store" />
              </div>
            </div>
            {/* col */}
            <div className="col-lg-6 col-sm-6 col-xs-6 p-1">
              <div className="store-img object-fit">
                <img src="images/store-6.jpg" alt="Store" />
              </div>
            </div>
            {/* col */}
          </div>
        </div>
      </div>

      <div className="main-section customer-insta pt-0 border-bottom">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 col-sm-10 col-xs-12 m-auto">
              <div className="bg-site customer-insta-container">
                <h4 className="lobster text-white">Stay in the know!</h4>
                <div className="customer-slider owl-carousel">
                  <div className="item">
                    <div className="customer-box object-fit">
                      <a href="#">
                        <img src="images/whiteshut.jpg" alt="Our Customer" />
                        <div className="customer-post">
                          <p>
                            <small>
                              Loremen Ipsumes is simply dummy text of the
                              printing and typesetting industry. @fashionHub
                              #fashionHub #model #fashion
                            </small>
                          </p>
                        </div>
                      </a>
                    </div>
                  </div>
                  {/* item */}
                  <div className="item">
                    <div className="customer-box object-fit">
                      <a href="#">
                        <img src="images/store-3.jpg" alt="Our Customer" />
                        <div className="customer-post">
                          <p>
                            <small>
                              Loremen Ipsumes is simply dummy text of the
                              printing and typesetting industry. @fashionHub
                              #fashionHub #model #fashion
                            </small>
                          </p>
                        </div>
                      </a>
                    </div>
                  </div>
                  {/* item */}
                  <div className="item">
                    <div className="customer-box object-fit">
                      <a href="#">
                        <img src="images/store-4.jpg" alt="Our Customer" />
                        <div className="customer-post">
                          <p>
                            <small>
                              Loremen Ipsumes is simply dummy text of the
                              printing and typesetting industry. @fashionHub
                              #fashionHub #model #fashion
                            </small>
                          </p>
                        </div>
                      </a>
                    </div>
                  </div>
                  {/* item */}
                  <div className="item">
                    <div className="customer-box object-fit">
                      <a href="#">
                        <img src="images/kasmiri.jpg" alt="Our Customer" />
                        <div className="customer-post">
                          <p>
                            <small>
                              Loremen Ipsumes is simply dummy text of the
                              printing and typesetting industry. @fashionHub
                              #fashionHub #model #fashion
                            </small>
                          </p>
                        </div>
                      </a>
                    </div>
                  </div>
                  {/* item */}
                  <div className="item">
                    <div className="customer-box object-fit">
                      <a href="#">
                        <img src="images/fitness-2.jpg" alt="Our Customer" />
                        <div className="customer-post">
                          <p>
                            <small>
                              Loremen Ipsumes is simply dummy text of the
                              printing and typesetting industry. @fashionHub
                              #fashionHub #model #fashion
                            </small>
                          </p>
                        </div>
                      </a>
                    </div>
                  </div>
                  {/* item */}
                </div>
                <p className="fs-20 text-white">
                  pint it . tag it, tweet it. <br />
                  #fashionHub for a chance to be featured!
                </p>
                <div className="stay-with border-top">
                  <p className="wow fadeInUp text-light">
                    <a href="#" className="text-light">
                      @fashionHub
                    </a>{" "}
                    |{" "}
                    <a href="#" className="text-light">
                      #fashionHub
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AboutUs;
